/**
 * 加自选
 */
import React, { useState } from "react"
import { ZXLayer } from "../layer";
import { quotedata } from "../quotedata"
import { isWeChat } from "../utils"
import "./index.less"

export function ZXPop(props: { onClose: Function; quotedata: quotedata; cancelEvent: Function }) {
  const cancel = () => {
    props.cancelEvent()
    try {
      // 大数据埋点
      window.sendTrackLog("div", "click", "ggxqy_djzxcfdc_qx")
    } catch (error) {}
    props.onClose()
  }

  const goToApp = () => {
    try {
      if (!isWeChat()) {
        window.location.href = "https://emstatic.eastmoney.com/awaken/app/share.html?linktype=818&stockCode=" + props.quotedata.code + "&market=" + props.quotedata.market + "&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0005084a"
      }
      // 大数据埋点
      window.sendTrackLog("div", "click", "ggxqy_djzxcfdc_tzapp")
      props.onClose()
    } catch (error) {}
  }

  return (
    <>
      <div className="zx-pop">
        <p>去APP内加自选，个股动态实时知晓！</p>
        <div>
          <a className="cancelApp" onClick={cancel}>
            取消
          </a>
          <a className="goApp" onClick={goToApp}>
            前往
          </a>
        </div>
      </div>
      <ZXLayer />
    </>
  )
}
